import { Group, Text, Container, Card, Flex, Button } from '@mantine/core';
import { IconHelp } from '@tabler/icons-react';
import { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useDocumentTitle } from '@mantine/hooks';
import { HeaderMenu } from "../../components/HeaderMenu/HeaderMenu";
import { useNavigate } from "react-router-dom";
import { SelectTooltip } from "../../components/GeneralComponent/GeneralComponent";
import GeneralComponentApi from "../../api/GeneralComponentApi";

export function BillingDetails() {
  useDocumentTitle("Visiopt - Billing");
  const navigate = useNavigate();

  const [selectedMemberWebsite, setSelectedMemberWebsite] = useState('');
  const billingIconRef = useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpTargetId, setHelpTargetId] = useState(0);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const [billingPortalUrl, setBillingPortalUrl] = useState('');
  const [cancelAccountMsg, setCancelAccountMsg] = useState('');
  const [showBillingPortal, setShowBillingPortal] = useState(false);

  const handleHeaderMenuComponentChange = (Value:any) => {
    setSelectedMemberWebsite(Value);
  };

  useEffect(() => {
    GeneralComponentApi.getbillingdetails()
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        setBillingPortalUrl(data.data.biling_portal_url);
        setCancelAccountMsg(data.data.cancelled_account_msg);
        setShowBillingPortal(data.data.biling_portal_url_show);
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  }, [navigate]);

  const handleAccessBillingPortal = () => {
    window.open(billingPortalUrl, '_blank');
  };

  const handleHelpClick = (id:any) => {
    setShowHelpModal(true);
    setHelpTargetId(id);
    if (billingIconRef.current) {
      const { top, left, width } = billingIconRef.current.getBoundingClientRect();
      const scrollOffset = window.scrollY;
      setTooltipPosition({
        top: top + scrollOffset,
        left: left + width + 10, 
      });
    }
  };

	return (
		<>
      <HeaderMenu HeaderMenuValue={selectedMemberWebsite} HeaderMenuOnChange={handleHeaderMenuComponentChange}/>
      {showHelpModal &&
      ReactDOM.createPortal(
        <div style={{ zIndex: 9999 }}>
          <SelectTooltip
            isVisible={showHelpModal}
            setIsVisible={setShowHelpModal}
            id={helpTargetId}
            tooltipPosition={tooltipPosition}
          />
        </div>,
        document.body
      )}
      <Container size="xl">
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Group position="apart" mb="xs">
            <Text weight={500}>BILLING <IconHelp ref={billingIconRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(166)}/></Text>
          </Group>
          <Text mt={20}>{cancelAccountMsg}</Text>
          {showBillingPortal && (
            <>
              <Flex justify="center" mt={10}>
                <Text weight={500} align="center" style={{ fontSize: "20px" }}>If you would like to upgrade or downgrade your account, please contact support@visiopt.com</Text>
              </Flex>
              <Flex justify="center" mt={20} mb={10}>
                <Button style={{ fontSize: "18px" }} onClick={handleAccessBillingPortal}>Access Your Billing Portal</Button>
              </Flex>
            </>
          )}
        </Card>
      </Container>
		</>
	);
}